import { Step, Typography } from '@mui/material';
import React from 'react';

import CustomStepAvatar from 'components/shared/Stepper/CustomStepAvatar';
import CustomStepContent from 'components/shared/Stepper/CustomStepContent';
import CustomStepper from 'components/shared/Stepper/CustomStepper';
import getRegionalDate, { monthOptions } from 'helpers/getRegionalDate';
import { RouterOutputs } from 'helpers/trpc';

// both getAcademyAnalysisTrainingSessionDashboard and getAcademyAnalysisLabSessionDashboard returns same types of objects
type Trial =
  RouterOutputs['academyAnalysis']['getAcademyAnalysisTrainingSessionDashboard']['newTrialLog'][number];
interface Props {
  trials: Trial[];
}

const TrialLogSection = ({ trials }: Props) => (
  <CustomStepper>
    {trials.map((trialLog, index) => (
      <Step key={index} expanded={true}>
        <CustomStepAvatar imageSource={trialLog.profileImagePath} />

        <CustomStepContent currentStep={index} steps={trials.length}>
          <Typography variant="h3" mb={0.5}>
            {trialLog.name}
          </Typography>

          <Typography variant="h3" mb={0.5}>
            {trialLog.drillTitle}
          </Typography>

          <Typography>{`Score: ${trialLog.score.toFixed(2)}`}</Typography>

          <Typography>
            {getRegionalDate(trialLog.date, monthOptions)}
          </Typography>
        </CustomStepContent>
      </Step>
    ))}
  </CustomStepper>
);

export default TrialLogSection;
